/**
 * Mascot Domain — Djay Mascot System
 *
 * Barrel export for the Djay mascot components, hooks, animations, and messages.
 * DDD co-locatie: moved from components/mascot/ in s60.
 *
 * Usage:
 * ```tsx
 * import { DjayAvatar, DjayBubble, getDjayGreeting, djayVariants } from '../mascot'
 * ```
 */

// Core components
export { DjayAvatar, VARIANT_COLORS } from './DjayAvatar'
export type {
  DjaySize,
  DjayEmotion,
  DjayTier,
  DjayVariant,
  DjayAccessory,
  DjayAvatarProps,
} from './DjayAvatar'

export { DjayBubble } from './DjayBubble'
export type { DjayBubbleProps, BubbleColorScheme } from './DjayBubble'

export { FloatingDjay } from './FloatingDjay'

// DjayShowcase: moved from components/mascot/ in s70 (CL-3 complete)
export { DjayShowcase } from './DjayShowcase'

export { DjayMeesterLogo } from './DjayMeesterLogo'
export type { DjayMeesterLogoProps } from './DjayMeesterLogo'

// Hooks
export { useDjaySelection } from './useDjaySelection'
export { useVariantUnlocks, TOTAL_VARIANTS } from './useVariantUnlocks'
export type {
  VariantUnlockInfo,
  VariantProgress,
  MascotRarity,
} from './useVariantUnlocks'
export { useLearnerContext, useLearnerBasics } from './useLearnerContext'

// Config (timings + thresholds — single source of truth for magic numbers)
export { DJAY_TIMINGS, DJAY_THRESHOLDS, DJAY_TIME_EGGS } from './config'

// Messages / Copy Registry
export {
  getDjayGreeting,
  getDjayPersonalGreeting,
  getDjayCorrectReaction,
  getDjayIncorrectReaction,
  getDjayHintPrompt,
  getDjaySummaryReaction,
  getDjayLevelUpReaction,
  getDjayReturnGreeting,
  getDjayCheatsheetIntro,
  getDjayCheatsheetFallback,
  getDjayDailyGoalReaction,
  getDjayDailyTip,
  getDjayThinkingMessage,
  getDjayFirstTimeSubject,
  getDjayMissionHeading,
  getDjayLabWelcome,
  getDjayModeIntro,
  getDjayViewMessage,
  getDjayIdleMessage,
  getDjaySplashMessage,
  getDjayDistractorIntro,
  getDjayExplanationIntro,
  getDjayWelcomeMessage,
  getDjayRegistrationStep,
  getDjayTeacherOnboardingStep,
  shouldDjayReact,
} from './djayMessages'
export type { DjayMessage, LearnerContext } from './djayMessages'

// Easter Eggs (DDD co-locatie: mascot domain)
export { useEasterEggs } from './useEasterEggs'
export {
  EASTER_EGGS,
  RAPID_TAP_ESCALATION,
  checkTimeBasedEgg,
  createRapidTapDetector,
  createKonamiDetector,
  getRapidTapReaction,
} from './easterEggs'
export type {
  EasterEggId,
  EasterEggReaction,
  EasterEggDefinition,
  EasterEggSound,
} from './easterEggs'

// Animations
export { djayVariants } from './animations/transitions'

// Illustrations
export { getAchievementIllustration } from './illustrations'
export { DjayIllustrationBase } from './illustrations'
export type { DjayIllustrationProps, AchievementRarity } from './illustrations'
